var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "orages") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 128.01,
    cy: 128.27,
    r: 99.94,
    fill: "#450168",
    id: "background"
  }), /*#__PURE__*/React.createElement("g", {
    id: "main_element",
    transform: "matrix(0.95,0,0,0.95,6.3837821,6.3487011)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    d: "m 170.37,94.7 h -0.51 C 167.88797,77.595355 149.13939,68.011231 134.12,76.43 128.31773,64.422772 114.98936,58.016689 101.98859,60.986516 88.987825,63.956344 79.763072,75.514346 79.75,88.85 c 0.01378,2.151662 0.248347,4.29623 0.7,6.4 -9.682367,2.295828 -16.117697,11.47024 -14.979901,21.3558 C 66.607896,126.49137 74.959233,133.96388 84.91,134 l 3.22,-0.13 29.87178,0.14273 -9.98724,-36.180919 37.87368,36.200919 21.00178,-0.14273 3.46,0.13 c 10.85793,0 19.65999,-8.80208 19.65999,-19.66 0,-10.85792 -8.80206,-19.66 -19.65999,-19.66 z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    d: "m 127.01855,144.17858 h -16.11007 l 44.47203,43.18598 -12.38906,-32.76887 h 16.11007 l -43.42604,-43.16026 z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b5a4cb2993114e9c618244ae195635f6.svg";
export { ForwardRef as ReactComponent };